import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { VisorWrapperComponent } from './visor-wrapper/visor-wrapper.component';
import { VisorRoutingModule } from './visor-routing.module';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [VisorWrapperComponent],
  imports: [
    SharedModule,
    CommonModule,
    VisorRoutingModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class VisorWrapperModule { }
